import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { SvgIcon } from "@mui/material";
import { ContactType, ContactTypeIcon } from "../../enums/ContactType";
import { PriorityNoteNoteType } from "../../graphql/graphql";
import { formatDateTime } from "../../utils/Date.utils";
import { ImageWithPlaceholder } from "../../shared/ImageWithPlaceholder";
export const PriorityNote = ({ priorityNote: { 
// priorityNoteId,
note, name, imageUrl, noteType, createdAt, contactType, contactReason, contactOutcome } }) => {
    const isSystemNote = noteType === PriorityNoteNoteType.System;
    // Delete/Archive Confirmation Modal State
    const [opened, { open, close }] = useDisclosure(false);
    const noteText = note
        .replace(/\\n\\n/g, "\n")
        .replace("\n\n", "\n")
        .split("\n");
    const handleDeleteNote = async () => {
        if (!opened) {
            open();
            return;
        }
        else {
            // TODO: Implement delete priority note
        }
    };
    return (_jsxs(Flex, { className: "hover-green hover-opacity-parent", gap: "xs", style: {
            minHeight: isSystemNote ? "50px" : "70px",
            borderRadius: "0.65rem",
            padding: "0.5rem"
        }, children: [_jsx(ImageWithPlaceholder, { avatarText: name, size: 35, imageUrl: imageUrl }), _jsxs(Stack, { flex: 1, children: [_jsxs(Flex, { justify: "space-between", children: [_jsxs(Flex, { align: "center", gap: "xs", children: [name && (_jsx(Text, { variant: "body", fw: 700, children: name })), isSystemNote && (_jsx(Text, { variant: "meta", fw: 700, c: "gray.5", children: "(Automated)" }))] }), _jsxs(Flex, { gap: "xs", children: [contactType && contactType !== ContactType.NONE && (_jsx(SvgIcon, { component: ContactTypeIcon[contactType], color: "disabled", style: {
                                            fontSize: "1rem"
                                        } })), createdAt && (_jsx(Text, { variant: "meta", children: formatDateTime(createdAt) }))] })] }), _jsxs(Stack, { children: [noteText &&
                                noteText.map((noteText, index) => (_jsx(Text, { variant: "paragraph", children: noteText }, index))), !isSystemNote && (_jsxs(Flex, { gap: "sm", children: [_jsxs(Text, { className: "hover-opacity", variant: "meta-hidden", children: ["Intent: ", contactReason || "N/A"] }), _jsx(Text, { className: "hover-opacity", variant: "meta-hidden", children: "\u2022" }), _jsxs(Text, { className: "hover-opacity", variant: "meta-hidden", children: ["Outcome: ", contactOutcome || "N/A"] })] }))] })] })] }));
};
